import store from '../store';

export const isAuthenticatedGuard =  (to, from, next) => {
    if (store.getters["auth/isAuthenticated"]) {
        next();
    } else {
       store.dispatch('auth/logout');
        next({ name: 'Login' });
    }
}
export const isSuperAdmin = () => {
    return store.getters["auth/getRole"] === 'ROLE_SUPER_ADMIN';
}

export const isGestor = () => {
    return store.getters["auth/getRole"] === 'ROLE_GESTOR' || store.getters["auth/getRole"] === 'ROLE_SUPER_ADMIN';
}

export const conditionalNext = function(condition) {
    return (to, from, next) => {
        if (condition) {
            next();
            return
        }
        next({ name: 'Login' });
    }
}

